import { combineReducers } from "redux";
import invoiceRowReducer from "./invoice-reducers/add-order-reducer";
import bulkPurchaseReducer from "./purchase-sec-reducer.js/bulk-purchasee-reducer";

const rootReducer = combineReducers({ invoiceRowReducer, bulkPurchaseReducer });

export default rootReducer;
